"use strict";

import {getGeocode} from "use-places-autocomplete";

const fetchAddressSuggestionDetails = (suggestion={})=>{
    return new Promise((resolve, reject)=>{
        if(suggestion?.place_id){
            getGeocode({placeId: suggestion?.place_id}).then((results)=>{
                const addressComponents = results[0]?.address_components || [];
                const componentTypeMap = {
                    street_number: {name: 'street_number', format: 'long_name',},
                    route: {name: 'address', format: 'short_name',},
                    locality: {name: 'city', format: 'long_name',},
                    administrative_area_level_1: {name: 'state', format: 'short_name',},
                    postal_code: {name: 'zip5', format: 'long_name',},
                    postal_code_suffix: {name: 'zip4', format: 'long_name',},
                    country: {name: 'country', format: 'short_name',},
                };
                const componentTypeMapKeys = Object.keys(componentTypeMap);
                const address = {};
                addressComponents.forEach((component=[], index)=>{
                    const componentTypes = component.types || [];
                    if(componentTypes && componentTypes.length){
                        for (let i = 0; i < componentTypes.length; i++) {
                            const type = componentTypes[i] || '';
                            if(!!componentTypeMap[type]){
                                address[ componentTypeMap[type].name ] = component[componentTypeMap[type].format];
                                break;
                            }
                        }
                    }
                });
                address.address = `${address?.street_number || ''} ${address?.address || ''}`;
                address.zip = `${address?.zip5 || ''}${address?.zip4 || ''}`;
                delete address.street_number;
                delete address.zip5;
                delete address.zip4;
                resolve(address);
            });
        }else{
            resolve(null);
        }
    });
};

export default fetchAddressSuggestionDetails;
